export default __webpack_public_path__ + "static/media/2fa_email.515e8d75.png";